import { render } from "./dot.vue?vue&type=template&id=65033ada&scoped=true"
import script from "./dot.vue?vue&type=script&lang=js"
export * from "./dot.vue?vue&type=script&lang=js"

import "./dot.vue?vue&type=style&index=0&id=65033ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65033ada"]])

export default __exports__